<template>
    <div>
        <div class="card block-target">
            <div class="card-header header-elements-inline pt-2 pb-2">
                <h5 class="card-title font-weight-bold">Users</h5>
                <div class="header-elements">
                    <div class="list-icons">

                    </div>
                    <div class="list-icons mr-2  ml-auto">
                        <button class="btn btn-ums" @click="openModal(true)" v-if="hasRole($const.ROLES.SETTINGS_USER_SAVE)">Create</button>
                    </div>
                    <div class="list-icons">
                        <block-target ref="blockTarget" @search="search" :class="'list-icons-item'"/>
                    </div>
                </div>
            </div>
            <basic-table :fields="tableFields" name="templateList" :list="users" class="hover-table" @rowClickEvent="rowClickEvent">
                <template v-slot:regDtm="slotData">
                    {{slotData.data.sysRegDtm | datetimeFormat('HH:mm DD/MM/YYYY')}}
                </template>
            </basic-table>
        </div>
        <user-save-modal :propsData="userInfo" :isCreateModal="isCreateModal" :userList="users" :target="modalTarget"/>
    </div>
</template>

<script>
    import BasicTable from "@/components/form/table/BasicTable";
    import BlockTarget from "@/components/block/BlockTarget";
    import api from "@/api/support";
    import UserSaveModal from "@/components/modal/UserSaveModal";
    export default {
        name: "UserMng",
        components:{
            UserSaveModal,
            BlockTarget,
            BasicTable,
        },
        data() {
            return {
                modalTarget:'userModal',
                isCreateModal:true,
                userInfo:{
                    usrId:'',
                    usrNm:'',
                    usrType:'',
                    usrRole:'',
                    usrPw:''
                },
                tableFields:[
                    {key:'usrId',label:'User Id',width:'33.3%'},
                    {key:'usrType',label:'User Type',width:'33.3%'},
                    {key:'sysRegDtm',label:'Reg Date',width:'33.3%',slot:'regDtm'},
                ],
                users:[]
            }
        },
        mounted() {
            this.search()
        },
        methods: {
            openModal:function(isCreateModal,data) {
                this.isCreateModal = isCreateModal
                if(!isCreateModal) {
                    this.userInfo = data
                } else {
                    this.userInfo = {
                        usrId:'',
                        usrNm:'',
                        usrType:'',
                        usrRole:'',
                        usrPw:''
                    }
                }

                $('#'+this.modalTarget).modal('toggle')
            },
            search:function() {
                this.$refs.blockTarget.block()
                api.getUserList(this.params).then((res) => {
                    if(res.data && res.data.code === 1000) {
                        this.users = res.data.content
                    }
                }).finally(()=> {
                    this.$refs.blockTarget.unblock()
                })
            },
            rowClickEvent: function(item) {
                if(!this.hasRole(this.$const.ROLES.SETTINGS_USER_SAVE)) return
                this.openModal(false,item)
            }
        },
    }
</script>

<style scoped>

</style>
